import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/CommissionSchema/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/CommissionSchema/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/CommissionSchema/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/CommissionSchema/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/CommissionSchema/Delete',
    method: 'delete',
    data,
  })
}
